import type { ReactNode } from "react";

export type ErpGlyphName =
  | "manufacturing"
  | "ledger"
  | "sales"
  | "purchase"
  | "inventory"
  | "outbound"
  | "master"
  | "organization"
  | "subscription"
  | "security"
  | "warning"
  | "wallet"
  | "settlement"
  | "finance";

const glyphs: Record<ErpGlyphName, ReactNode> = {
  manufacturing: (
    <>
      <path d="M3 17V9l5-3v4l5-3v10H3Z" />
      <path d="M13 17h4V3h-3v7M5.5 13h2M10 13h1" />
    </>
  ),
  ledger: (
    <>
      <path d="M4.3 3.7h11.4v12.6H4.3z" />
      <path d="M7 7h6M7 10h6M7 13h3.4" />
      <path d="M2.6 6.1h1.7M2.6 9.1h1.7M2.6 12.1h1.7" />
    </>
  ),
  sales: (
    <>
      <path d="M3.2 4.2h2l1.2 7.3h8.4l1.5-5.3H6" />
      <path d="M8.1 8.6h5.9" />
      <circle cx="8" cy="14.7" r="1.1" />
      <circle cx="13.7" cy="14.7" r="1.1" />
    </>
  ),
  purchase: (
    <>
      <path d="M3.5 7.1 10 3.4l6.5 3.7v8.3h-13z" />
      <path d="M7.1 15.4v-4.2h5.8v4.2M6.1 7.6h7.8" />
      <path d="M10 3.4v4.2" />
    </>
  ),
  inventory: (
    <>
      <path d="m3.5 6.2 6.5-3 6.5 3-6.5 3z" />
      <path d="m3.5 6.2.1 7.4 6.4 3.2 6.4-3.2.1-7.4" />
      <path d="M10 9.2v7.6M6.7 7.7l6.5-3" />
    </>
  ),
  outbound: (
    <>
      <path d="M3.3 4.1h8.6v11.8H3.3z" />
      <path d="M6.2 7h3M6.2 9.8h3" />
      <path d="M10.8 12.7h5.8M14.1 10.2l2.5 2.5-2.5 2.5" />
    </>
  ),
  master: (
    <>
      <path d="M3.4 3.8h5.1v5.1H3.4zM11.5 3.8h5.1v5.1h-5.1zM3.4 11.1h5.1v5.1H3.4z" />
      <path d="M11.5 13.7h5.1M14.1 11.1v5.2" />
    </>
  ),
  organization: (
    <>
      <rect x="7.2" y="3" width="5.6" height="4" rx="0.8" />
      <rect x="2.8" y="13" width="5" height="4" rx="0.8" />
      <rect x="12.2" y="13" width="5" height="4" rx="0.8" />
      <path d="M10 7v3.1M5.3 13v-2.9h9.4V13" />
    </>
  ),
  subscription: (
    <>
      <rect x="2.8" y="4.2" width="14.4" height="11.6" rx="1.5" />
      <path d="M2.8 7.8h14.4M5.7 12h3.5" />
      <path d="M13.2 10.5v3M11.7 12h3" />
    </>
  ),
  security: (
    <>
      <path d="M10 2.8 16 5v4.4c0 3.5-2 6.2-6 7.8-4-1.6-6-4.3-6-7.8V5z" />
      <path d="m7.2 9.8 1.8 1.8 3.9-4" />
    </>
  ),
  warning: (
    <>
      <path d="m10 3.1 7.2 13H2.8z" />
      <path d="M10 7v4.3M10 14.1v.1" />
    </>
  ),
  wallet: (
    <>
      <path d="M3 5.2h12.7v10.2H3z" />
      <path d="M3 5.2 12.8 3v2.2M11.5 9h5.4v3.4h-5.4z" />
      <path d="M13.8 10.7h.1" />
    </>
  ),
  settlement: (
    <>
      <circle cx="6.2" cy="10" r="3.2" />
      <circle cx="13.8" cy="10" r="3.2" />
      <path d="M8.7 7.9h2.6M8.7 12.1h2.6M4.9 10h2.6M12.5 10h2.6" />
      <path d="m5.7 8.7 1.3 1.3-1.3 1.3M14.3 8.7 13 10l1.3 1.3" />
    </>
  ),
  finance: (
    <>
      <path d="M3.2 4.2h13.6v12H3.2z" />
      <path d="M3.2 7.7h13.6M7.1 7.7v8.5M12.9 7.7v8.5" />
      <path d="M5.1 10.4h.1M9.9 10.4h.1M14.8 10.4h.1M5.1 13.5h.1M9.9 13.5h.1M14.8 13.5h.1" />
    </>
  ),
};

export function ErpGlyph({
  name,
  className,
}: {
  name: ErpGlyphName;
  className?: string;
}) {
  return (
    <svg
      className={className ? `erp-glyph ${className}` : "erp-glyph"}
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
    >
      {glyphs[name]}
    </svg>
  );
}
